import { useTranslation } from "next-i18next";
import { ReactNode, useState } from "react";
import { ArrowDownIcon, ArrowUpIcon } from "@talladega/icons";

type Props = {
  children: ReactNode;
  button?: (open: boolean) => ReactNode;
};

export const DisclosureSearchFilter = ({ children, button }: Props) => {
  const { t } = useTranslation(["common"]);
  const [isOpen, setIsOpen] = useState(false);

  const getButton = (open: boolean) => {
    const defaultButton = (
      <button type="button" onClick={() => setIsOpen(!isOpen)}>
        <p className="flex items-center justify-center gap-2 text-sm font-semibold text-primary-500">
          {open ? t("common:hide_filters") : t("common:show_filters")}
          {!open && <ArrowDownIcon />}
          {open && <ArrowUpIcon />}
        </p>
      </button>
    );

    return button ? button(open) : defaultButton;
  };

  return (
    <>
      {/* Removed usage of `Transition` and `Disclosure` components.
          There's an issue with stacking context when these components are mounted.
      */}
      {isOpen && children}
      <div className="w-full flex justify-center">{getButton(isOpen)}</div>
    </>
  );
};

export default {};
